import {
  AfterViewInit,
  ContentChildren,
  Directive,
  ElementRef,
  HostListener,
  QueryList,
} from "@angular/core";
import { AppDragFixLeftDirective } from "./ScrollFixLeft.directive";

@Directive({
  selector: "[appScrollFixArea]",
})
export class ScrollFixAreaDirective implements AfterViewInit {
  @ContentChildren(AppDragFixLeftDirective, { descendants: true })
  fixables: QueryList<AppDragFixLeftDirective>;

  constructor(private element: ElementRef) {}

  ngAfterViewInit() {
    setTimeout(() => {
      this.element.nativeElement.scrollTop =
        sessionStorage.getItem("scrollTop");
    }, 500);
  }

  @HostListener("scroll", ["$event"])
  private onScroll($event: Event): void {
    sessionStorage.setItem("scrollTop", $event.currentTarget["scrollTop"] + "");
    this.fixables.forEach((fixable) => {
      fixable.leftPosition = $event.currentTarget["scrollLeft"];
    });
  }
}
